import Vue from 'vue';

const supportWebP = (function() {
  var canvas = typeof document === 'object' ? document.createElement('canvas') : {};
  canvas.width = canvas.height = 1;
  return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
})();

Vue.directive('webp', {
  inserted(el, binding) {
    if (!binding.value || !supportWebP) return;
    if (el.tagName.toLowerCase() === 'img') {
      if (/\.(png|jpeg|jpg)/.test(el.dataset.src)) {
        el.dataset.src = binding.value;
      } else if (/\.(png|jpeg|jpg)/.test(el.src)) {
        el.src = binding.value;
      }
    } else if (el.tagName.toLowerCase() === 'video') {
      el.poster = binding.value;
    }
  }
});
